import { render, staticRenderFns } from "./cardCount.vue?vue&type=template&id=84a37aaa"
import script from "./cardCount.vue?vue&type=script&lang=js"
export * from "./cardCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports